import React from 'react';
import { Button } from 'components/shadcn/ui/button';
import { useLocation } from 'react-router-dom';

const EditNameButton = ({ item }) => {
    const { pathname } = useLocation();
    const editName = (e) => {
        e.stopPropagation();
        const packOrMasterSN = item?.P_serialNumber ?? item?.M_serialNumber;
        const clickedFromTable = item?.fromTable ? `/${packOrMasterSN}` : '';
        const route = `${pathname}${clickedFromTable}/edit-device-profile`;
        window.location.href = route;
    };

    return (
        <>
            {item?.PackName || item?.MasterName ? (
                <span className="text-muted-foreground w-max">
                    {item?.PackName ?? item?.MasterName}
                </span>
            ) : (
                <Button
                    variant="outline"
                    onClick={editName}
                    size="sm"
                    className="min-w-[100px]"
                >
                    Edit Name
                </Button>
            )}
        </>
    );
};

export default EditNameButton;
